module.exports = __webpack_public_path__ + "85bf9f92a1c59563b99e8dd5d41b8a95.pdf";